import { YuLifeLocale } from "@hooks";

export const getNoPostsTitle = (locale: YuLifeLocale) => {
  if (locale === "jp") {
    return {
      title: "見つかりませんでした！",
      subtitle: "そのカテゴリーに一致する投稿はありません！",
    };
  }

  return {
    title: "Oh no!",
    subtitle: "There are no posts that match that category!",
  };
};
